<template>
  <div>
    <SfProperty :name="$t('order_reivice_label')"
      class="sf-property--full-width property" >
      <template #value>
        <SfLink href="#" @click="openModal()" link="">
          {{ $t('order_reivice_btn') }}
        </SfLink>
      </template>
    </SfProperty>
    <confirmModal
        ref="orderReiviceModal"
        @close="close"
        @ok="orderReceivingOk"
        :showFooter="true"
        class="orderReiviceModal"
      ></confirmModal>
  </div>
</template>
<script>
import {
  useOrderReceiving,
  useApiError
} from '@bee-hole/coms';
import {
  SfProperty,
  SfLink
} from '@storefront-ui/vue';
import { ref } from '@nuxtjs/composition-api';
import confirmModal from '~/components/ContentModal/confirm';
export default {
  name: 'orderReivice',
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  setup(prop, { emit, root }) {
    const orderReiviceModal = ref();
    const { set: setError } = useApiError();
    const { orderReceiving, result } = useOrderReceiving('orderReceiving');
    const orderReceivingOk = async () => {
      await orderReceiving(prop.orderId);
      if (result.value && result.value.status === "ORDER_WAIT_RATE") {
        setError({
          code: 0,
          message: root.$t('order_reivice_success')
        });
      }
      emit('ok');
    };
    const close = () => {
      // orderReiviceModal.value.close();
    };
    const openModal = () => {
      orderReiviceModal.value.setModal({
        title: root.$t('order_reivice_label'),
        context: root.$t('order_reivice_message'),
        showFooter: true
      });
    }
    return {
      orderReceivingOk,
      orderReiviceModal,
      close,
      openModal
    };
  },
  components: {
    SfProperty,
    SfLink,
    confirmModal
  }
};
</script>
<style lang="scss">
.orderReiviceModal{
 @include for-desktop{
   --modal-width: 60vw;
  --modal-top: 20rem;
  // --modal-max-height: 610px;
  .sf-textarea textarea {
      width: 95%;
      margin-top:0.5rem;
  }
  .sf-modal__container{
    max-width: 500px;
  }
 }
 @include for-mobile{
  --modal-width: 80vw;
  --modal-height: 18rem;
  --modal-top: 5%;
  .sf-textarea textarea {
      width: 85%;
      margin-top:0.5rem;
  }
 }
 .sf-textarea__label{
   margin-bottom: 0.5rem;
 }
}
</style>
